/* @flow */
// "Add to home screen" in the menu (phones, tablets, in a browser).
// It is a shortcut to this web player, not an App Store / Google Play app, so the
// wording says so. Where the browser offers a one-tap install (Chrome, Edge,
// Samsung Internet on Android) we use it; everywhere else we show general steps
// that work in any browser (Safari, Chrome on iPhone, Firefox ...).
import React from 'react'
import { NavLink } from 'reactstrap'
import { isDevice } from '../../helpers/device'
import { isApp } from '../../helpers/nativeApp'

// Chrome fires this early, sometimes before React mounts: keep hold of it
let deferredPrompt = null
const listeners = []
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    listeners.forEach((fn) => fn())
  })
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    listeners.forEach((fn) => fn())
  })
}

export const isInstalled = () => {
  // Inside the GymRadio phone app there is nothing to add to the home screen
  if (isApp()) return true
  try {
    return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches
  } catch (e) {
    return false
  }
}

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" style={ { verticalAlign: '-3px', marginLeft: 6 } }>
    <path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

export default class AddToHomeScreen extends React.Component {
  state = { canPrompt: !!deferredPrompt, showSteps: false }

  componentDidMount () {
    this.onChange = () => this.setState({ canPrompt: !!deferredPrompt })
    listeners.push(this.onChange)
  }

  componentWillUnmount () {
    const i = listeners.indexOf(this.onChange)
    if (i >= 0) listeners.splice(i, 1)
  }

  async add (e) {
    if (e) e.preventDefault()
    if (!deferredPrompt) {
      this.setState({ showSteps: !this.state.showSteps })
      return
    }
    const p = deferredPrompt
    deferredPrompt = null
    this.setState({ canPrompt: false })
    try {
      p.prompt()
      await p.userChoice
    } catch (err) {
      this.setState({ showSteps: true })
    }
  }

  render () {
    if (isInstalled() || !isDevice()) return null
    const { showSteps } = this.state
    return (
      <div className={ `add-home ${this.props.wrapperClassName || ''}` }>
        <NavLink href="#" onClick={ (e) => this.add(e) } aria-expanded={ showSteps }>
          Add to home screen<HomeIcon />
        </NavLink>
        {
          showSteps && (
            <p className="add-home__steps">
              Open your browser’s menu and choose <strong>Add to Home Screen</strong> (on some phones it’s under <strong>Share</strong>).
              You’ll get a GymRadio.com icon that opens this player full screen. It’s a shortcut to the web player, not an app from the App Store or Google Play.
            </p>
          )
        }
      </div>
    )
  }
}
